export default {
  state: {
    message: '',
    theme: null,
    active: false,
  },
  mutations: {
    setTheme(state, theme) {
      state.theme = theme;
    },
    setMessage(state, message) {
      state.message = message;
    },
    alertActive(state, timeout = 6) {
      state.active = timeout;
    },
    resetAlert(state) {
      state.message = '';
      state.theme = null;
      state.active = false;
    },
    setAlert(state, bool) {
      state.active = bool;
    },
  },
  actions: {
    activeAlert({ commit }, params) {
      commit('setTheme', params.theme);
      commit('setMessage', params.message);
      commit('alertActive', params.timeout);
    },

    closeAlert({ commit }) {
      commit('resetAlert');
    },

    setAlert({ commit }, bool) {
      commit('setAlert', bool);
    },
  },
};
